import React, { useEffect, useState } from "react"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Label,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Input,
  InputGroup,
  CardTitle,
} from "reactstrap"
import { hasPermission } from "helpers/helpers"
import {
  getAllBonusesCall,
  updateUserStatus,
  updateUserWithdrawStatus,
} from "../../../helpers/repository"
import { apiError } from "../../../store/actions"
export default function AccountDetails(props) {
  const [isActive, setIsActive] = useState("")
  const [withdrawStatus, setwithdrawStatus] = useState(null)
  const [isWithdrawActive, setisWithdrawActive] = useState("")

  useEffect(() => {
    getDefaultState()
  }, [props.userData])
  const getDefaultState = () => {
    if (props.userData.user_status == 0) {
      setIsActive(false)
    } else {
      setIsActive(true)
    }

    let withdrawStatus
    if (
      props.userData.withdraw_status === null ||
      props.userData.withdraw_status === "SUCCESS"
    ) {
      withdrawStatus = "SUCCESS"
    } else if (
      props.userData.withdraw_status === "FAILED" ||
      props.userData.withdraw_status === "CANCELED"
    ) {
      withdrawStatus = "AVAILABLE"
    } else {
      withdrawStatus = props.userData.withdraw_status
    }
    const withdraw_status_array = ["SUCCESS", "AVAILABLE"]
    const WithdrawActive = withdraw_status_array.includes(withdrawStatus)
    setwithdrawStatus(withdrawStatus)
    setisWithdrawActive(WithdrawActive)
  }

  const changeUserStatus = () => {
    updateUserStatus(props.userData.id, !isActive).then(res => {
      console.log(res)
    })
  }

  const changeUserWithdrawStatus = () => {
    setisWithdrawActive(!isWithdrawActive)
    if (isWithdrawActive) {
      setwithdrawStatus("PENDING")
    } else {
      setwithdrawStatus("SUCCESS")
    }
    updateUserWithdrawStatus(props.userData.id, !isWithdrawActive).then(res => {
      console.log(res)
    })
  }

  return (
    <Col lg={6}>
      <Card>
        <CardBody>
          <CardTitle className="mb-4">Account Details</CardTitle>

          <Form>
            <div className="row mb-4">
              <Col xs={6} sm={4} md={4} lg={6}>
                <Label className="col-form-label">User ID</Label>
              </Col>
              <Col xs={6} sm={8} md={8} lg={6}>
                <p className="text-muted fw-medium col-form-label">
                  {props.userData.id}
                </p>
              </Col>
            </div>
            <div className="row mb-4">
              <Col xs={6} sm={4} md={4} lg={6}>
                <Label className="col-form-label">Referrer</Label>
              </Col>
              <Col xs={6} sm={8} md={8} lg={6}>
                <p className="text-muted fw-medium col-form-label">
                  {props.userData.ref_id}
                </p>
              </Col>
            </div>
            <div className="row mb-4">
              <Col xs={6} sm={4} md={4} lg={6}>
                <Label className="col-form-label">User Number</Label>
              </Col>
              <Col xs={6} sm={8} md={8} lg={6}>
                <p className="text-muted fw-medium col-form-label">
                  {props.userData.phone_number}
                </p>
              </Col>
            </div>
            <div className="row mb-4">
              <Col xs={6} sm={4} md={4} lg={6}>
                <Label className="col-form-label">User Name</Label>
              </Col>
              <Col xs={6} sm={8} md={8} lg={6}>
                <p className="text-muted fw-medium col-form-label">
                  {props.userData.first_name} {props.userData.last_name}
                </p>
              </Col>
            </div>
            <div className="row mb-4">
              <Col xs={6} sm={4} md={4} lg={6}>
                <Label className="col-form-label">Ref_source</Label>
              </Col>
              <Col xs={6} sm={8} md={8} lg={6}>
                <p className="text-muted fw-medium col-form-label">
                  {props.userData.referral_source}
                </p>
              </Col>
            </div>
            <div className="row mb-4">
              <Col xs={6} sm={4} md={4} lg={6}>
                <Label className="col-form-label">Date Joined</Label>
              </Col>
              <Col xs={6} sm={8} md={6} lg={6}>
                <p className="text-muted fw-medium col-form-label">
                  {props.userData.created_at
                    ? `${new Date(
                        Date.parse(props.userData.created_at)
                      ).toLocaleDateString("en-GB")} ${new Date(
                        Date.parse(props.userData.created_at)
                      ).toLocaleTimeString()}`
                    : ""}
                </p>
              </Col>
            </div>
            <div className="row mb-4">
              <Col xs={6} sm={4} md={4} lg={6}>
                <Label className="col-form-label">Origin</Label>
              </Col>
              <Col xs={6} sm={8} md={8} lg={6}>
                <p className="text-muted fw-medium col-form-label">Online</p>
              </Col>
            </div>

            <div className="row mb-4">
              <Col xs={6} sm={4} md={4} lg={6}>
                <Label className="col-form-label">Last Played</Label>
              </Col>
              <Col xs={6} sm={8} md={6} lg={6}>
                <p className="text-muted fw-medium col-form-label">
                  {props.userData.last_played
                    ? new Date(
                        Date.parse(props.userData.last_played)
                      ).toLocaleDateString("en-GB", {
                        timeZone: "CAT",
                      }) +
                      " " +
                      new Date(
                        Date.parse(props.userData.last_played)
                      ).toLocaleTimeString([], { timeZone: "CAT" })
                    : ""}
                </p>
              </Col>
            </div>
            <div className="row mb-4">
              <Col xs={6} sm={4} md={4} lg={6}>
                <Label className="col-form-label">Last Transaction</Label>
              </Col>
              <Col xs={6} sm={8} md={8} lg={6}>
                <p className="text-muted fw-medium col-form-label">
                  {props?.userData?.last_login
                    ? new Date(
                        Date.parse(props.userData.last_login)
                      ).toLocaleDateString("en-GB", {
                        timeZone: "CAT",
                      }) +
                      " " +
                      new Date(
                        Date.parse(props.userData.last_login)
                      ).toLocaleTimeString([], { timeZone: "CAT" })
                    : ""}
                </p>
              </Col>
            </div>
            <div className="row mb-4">
              <Col xs={6} sm={4} md={4} lg={6}>
                <Label className="col-form-label">Last Login</Label>
              </Col>
              <Col xs={6} sm={8} md={8} lg={6}>
                <p className="text-muted fw-medium col-form-label">
                  {new Date(
                    Date.parse(props?.userData?.last_login)
                  ).toLocaleDateString("en-GB")}{" "}
                  {new Date(
                    Date.parse(props?.userData?.last_login)
                  ).toLocaleTimeString()}
                </p>
              </Col>
            </div>
            <div className="row mb-4">
              <Col xs={6} sm={4} md={4} lg={6}>
                <Label className="col-form-label">Status</Label>
              </Col>
              <Col xs={6} sm={8} md={8} lg={6}>
                <p className="text-muted fw-medium col-form-label">
                  {isActive == true ? "Active" : "In-Active"}
                </p>
              </Col>
            </div>
            {hasPermission("update-end-user-status") && (
              <div className="row mb-4">
                <Col xs={6} sm={4} md={4} lg={6}>
                  <Label className="col-form-label">Change Status</Label>
                </Col>
                <Col
                  xs={6}
                  sm={8}
                  md={8}
                  lg={6}
                  className="form-check form-switch form-switch-md d-flex align-items-center"
                >
                  <input
                    style={{ left: "0" }}
                    type="checkbox"
                    className="form-check-input"
                    id="customSwitchsizemd"
                    onChange={e => {
                      setIsActive(!isActive)
                      changeUserStatus()
                    }}
                    checked={isActive}
                  />{" "}
                </Col>
              </div>
            )}
            <div className="row mb-4">
              <Col xs={6} sm={4} md={4} lg={6}>
                <Label className="col-form-label">Withdraw Status</Label>
              </Col>
              <Col xs={6} sm={8} md={8} lg={6}>
                <p className="text-muted fw-medium col-form-label">
                  {withdrawStatus}
                </p>
              </Col>
            </div>
            {hasPermission("update-end-user-withdraw-status") && (
              <div className="row mb-4">
                <Col xs={6} sm={4} md={4} lg={6}>
                  <Label className="col-form-label">
                    Change Withdraw Status
                  </Label>
                </Col>
                <Col
                  xs={6}
                  sm={8}
                  md={8}
                  lg={6}
                  className="form-check form-switch form-switch-md d-flex align-items-center"
                >
                  <input
                    style={{ left: "0" }}
                    type="checkbox"
                    className="form-check-input"
                    id="customSwitchsizemd"
                    onChange={e => {
                      // setisWithdrawActive(!isWithdrawActive)
                      changeUserWithdrawStatus()
                    }}
                    checked={isWithdrawActive}
                  />{" "}
                </Col>
              </div>
            )}
            <div className="row mb-4">
              <Col xs={6} sm={4} md={4} lg={6}>
                <Label className="col-form-label">KYC</Label>
              </Col>
              <Col xs={6} sm={8} md={8} lg={6}>
                <p className="text-muted fw-medium col-form-label">
                  {props.userData.p_status == 1
                    ? "Verified"
                    : props.userData.p_status == 2
                    ? "Declined"
                    : "Not Verified"}
                </p>
              </Col>
            </div>
          </Form>
        </CardBody>
      </Card>
    </Col>
  )
}
